import React from 'react'
import { IonIcon, IonButton, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import './patientSearchButton.component.css'
import { useOfflineStatus } from '../../../utilities/isOnline.util'

interface IPatientSearchProps {
  onClickAction: () => void
}

const PatientSearchButton: React.FC<IPatientSearchProps> = (props: IPatientSearchProps) => {
  const { t } = useTranslation()
  const { onClickAction } = props
  const isOfflineStatus = useOfflineStatus()

  const onPatientSearchClick = () => {
    onClickAction()
  }

  return (
    <IonButton
      data-testid='PatientSearchButton'
      className='patient-search-button'
      expand='block'
      fill='clear'
      disabled={isOfflineStatus}
      onClick={onPatientSearchClick}>
      <IonIcon className='icon-padding-right' src='/assets/images/folder-magnifying-glass.svg' size='medium' />
      <IonLabel>{t('patientSearch.patientSearch')}</IonLabel>
    </IonButton>
  )
}

export default PatientSearchButton
